<template>
  <div class="progress-bar-wrapper">
    <div class="d-flex justify-content-between">
      <div class="caption-s color-text-neutral-secondary">{{ label }}</div>
      <div class="caption-s semi-bold color-text-neutral-on-white">
        {{ $t("common.essaysGraded", { value, max }) }}
      </div>
    </div>

    <eg-b-progress class="mt-2" :max="max">
      <eg-b-progress-bar :value="value" :variant="variant"></eg-b-progress-bar>
    </eg-b-progress>
  </div>
</template>

<script>
export default {
  name: "EgProgressBar",

  props: {
    max: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
      default: 0,
    },
    variant: {
      type: String,
      default: "success",
      validator: (value) => ["success", "danger"].includes(value),
    },
    label: {
      type: String,
      default: "",
    },
    valueLabel: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-bar-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .progress {
    height: 6px;
    margin-bottom: 8px;
  }

  .progress-bar {
    background: linear-gradient(90deg, #8a3ffc 0%, #d76812 100%);
  }
}
</style>
